/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */

export const PLUS = "+";
export const DOT = ".";
export const SPACE = " ";
export const TABLE_KEY_ACTION = "Actions";
export const LOGONID = "logonId";
export const CUSTOMERID = "id";
export const ORDERID = "orderId";

export interface KeyLookup {
  key: string;
  translateKeyPrefix?: string;
}
export interface TableColumnDef {
  title: string;
  keyLookup: KeyLookup;
  idProp: string;
  sortable?: boolean;
}
export interface TableAction {
  label: () => string;
  action: Function;
  key: string;
}

export interface TableDialogMessage {
  key: string;
  params: any;
}
export interface TableDialogOption {
  message?: TableDialogMessage;
  onConfirm: Function;
  onCancel: Function;
  confirmLabel?: string;
  cancelLabel?: string;
}
